namespace GeniuzPOS.Member {
    export interface MbReport_01_Dt_Form {
    }

    export class MbReport_01_Dt_Form extends Serenity.PrefixedContext {
        static formKey = 'Member.MbReport_01_Dt_';
    }
}
